import { BaseApi } from "../BaseApi";
import { InterceptToken } from "../../interceptors/TokenInterceptor";

const obtenerIngresoUrl = "api/v1/websalud/primeraars/ingreso";
const obtenerReclamosIngresoUrl = "api/v1/websalud/primeraars/ingreso/reclamos";
const validarCoberturaIngresoUrl =
  "api/v1/websalud/primeraars/ingreso/cobertura/validacion";
const insertarCoberturaIngresoUrl =
  "api/v1/websalud/primeraars/ingreso/cobertura";
const eliminarCoberturaIngresoUrl =
  "api/v1/websalud/primeraars/ingreso/cobertura/eliminar";
const generarCierreCuentaUrl =
  "api/v1/websalud/primeraars/ingreso/cuenta/cerrar";
const consultarCierresCuentasUrl =
  "api/v1/websalud/primeraars/ingreso/cuentas/cierre";
const consultarCoberturasCierreUrl =
  "api/v1/websalud/primeraars/ingreso/coberturas";
const consultarReclamantesUrl =
  "api/v1/websalud/primeraars/ingreso/reclamantes";

const obtenerIngreso = (request) =>
  InterceptToken(BaseApi.get, obtenerIngresoUrl, request).then(
    (response) => response.data
  );

const consultarCierresCuentas = (request) =>
  InterceptToken(BaseApi.get, consultarCierresCuentasUrl, request).then(
    (response) => response.data
  );

const consultarCoberturasCierre = (request) =>
  InterceptToken(BaseApi.get, consultarCoberturasCierreUrl, request).then(
    (response) => response.data
  );

const consultarReclamantes = (request) =>
  InterceptToken(BaseApi.get, consultarReclamantesUrl, request).then(
    (response) => response.data
  );

const validarCoberturaIngreso = (request) =>
  InterceptToken(BaseApi.post, validarCoberturaIngresoUrl, request).then(
    (response) => response.data
  );

const insertarCoberturaIngreso = (request) =>
  InterceptToken(BaseApi.post, insertarCoberturaIngresoUrl, request).then(
    (response) => response.data
  );

const eliminarCoberturaIngreso = (request) =>
  InterceptToken(BaseApi.post, eliminarCoberturaIngresoUrl, request).then(
    (response) => response.data
  );

const generarCierreCuenta = (request) =>
  InterceptToken(BaseApi.post, generarCierreCuentaUrl, request).then(
    (response) => response.data
  );

  const obtenerReclamosIngreso = (request) =>
    InterceptToken(BaseApi.get, obtenerReclamosIngresoUrl, request).then(
      (response) => response.data
    );
  

const exportedObject = {
  obtenerIngreso,
  validarCoberturaIngreso,
  insertarCoberturaIngreso,
  eliminarCoberturaIngreso,
  generarCierreCuenta,
  consultarCierresCuentas,
  consultarCoberturasCierre,
  consultarReclamantes,
  obtenerReclamosIngreso
};

export default exportedObject;
